// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Api from "@react-google-maps/api";

function getGoogleConfig(config) {
  return {
          path: config.path,
          visible: config.visible,
          options: {
            strokeColor: config.color,
            strokeOpacity: config.opacity,
            strokeWeight: config.weight
          },
          ref: config.ref
        };
}

function PolylineComponentMod(Props) {
  var lib_nameOpt = Props.lib_name;
  var config = Props.config;
  var lib_name = lib_nameOpt !== undefined ? lib_nameOpt : /* GoogleMap */0;
  if (lib_name) {
    return null;
  }
  var googleConfig = getGoogleConfig(config);
  return React.createElement(Api.Polyline, {
              path: googleConfig.path,
              visible: googleConfig.visible,
              options: googleConfig.options,
              ref: googleConfig.ref
            });
}

var make = PolylineComponentMod;

export {
  getGoogleConfig ,
  make ,
  
}
/* react Not a pure module */
